import { connect } from 'react-redux'

import EmployeesComponent from './EmployeesQrCodes.js'

const mapStateToProps = (state, ownProps) => ({ employeeIds: ownProps.location.state.employeeIds, employees: state.employees.employeeRecord })

export default connect(mapStateToProps, null)(EmployeesComponent)
